import Python from "../images/skills/python.png"
import React from "../images/skills/react.png"
import Node from "../images/skills/node.png"
import Express from "../images/skills/express.png"
import MongoDB from "../images/skills/mongodb.png"
import HTML from "../images/skills/html.png"
import CSS from "../images/skills/css.png"
import JavaScript from "../images/skills/javascript.png"
import TypeScript from "../images/skills/typescript.png"
import Tailwind from "../images/skills/tailwind.png"
import Nextjs from "../images/skills/nextjs.svg"
import Opencv from "../images/skills/opencv.png"
import PostgreSQL from "../images/skills/postgresql.png"
import MySql from "../images/skills/mysql.png"
import Pytorch from "../images/skills/pytorch.png"
import Tensorflow from "../images/skills/tensorflow.png"
import Figma from "../images/skills/figma.png"

const tech_icons=[
    {name:"Python",image:Python},
    {name:"OpenCV",image:Opencv},
    {name:"Pytorch",image:Pytorch},
    {name:"Tensorflow",image:Tensorflow},
    {name:"HTML",image:HTML},
    {name:"CSS",image:CSS},
    {name:"Tailwind CSS",image:Tailwind},
    {name:"JavaScript",image:JavaScript},
    {name:"TypeScript",image:TypeScript},
    {name:"React js",image:React},
    {name:"Next.js",image:Nextjs},
    {name:"Node js",image:Node},
    {name:"Express js",image:Express},
    {name:"MongoDB",image:MongoDB},
    {name:"PostgreSQL",image:PostgreSQL},
    {name:"MySQL",image:MySql},
    {name:"Figma",image:Figma},
]

export default tech_icons